<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

@if (metadata?.showMetadata) {
    <div class="metadata-info-container">
        @if (metadata.title) {
            <div class="metadata-item metadata-title-item">
                <span class="font-sub2 font-color-secondary metadata-title"> {{ metadata.title }}: </span>
            </div>
        }
        @for (item of metadata.itemList; track item.icon; let i = $index) {
            @if (item.icon && item.text) {
                <div class="metadata-row">
                    <div
                        class="metadata-item"
                        matTooltip="{{ item.tooltipText }}"
                        nvDisableTooltipIfNeeded
                        matTooltipClass="mat-tooltip-font-body3"
                    >
                        <mat-icon svgIcon="{{ item.icon }}" class="metadata-icon {{ item.iconColor }}"></mat-icon>
                        <span dir="auto" class="metadata-text font-color-secondary">{{ item.text }}</span>
                    </div>
                    @if (dotVisibility[i]) {
                        <div class="dot-gap-one"></div>
                    }
                </div>
            }
        }
    </div>
}
